import { entityStateZodSchema } from "@@/shared/entity-status";
import { metaContentZodSchema } from "@@/shared/meta-content/meta-content";
import { priceZodSchema } from "@@/shared/prices/price";
import {
    productTemplateIdFactory,
    productTemplateIdZodSchema,
} from "@@/shared/products/templates/product-template-id";
import { templateDescriptionZodObject } from "@@/shared/products/templates/shared/template-description";
import { templateSpecificationZodObject } from "@@/shared/products/templates/shared/template-specification";
import { storageItemImageIdZodSchema } from "@@/shared/storage-items/storage-item-images/storage-item-image-id";
import { translatableZodSchema } from "@@/shared/translations/translation";
import type { Except } from "type-fest";
import { z } from "zod";

const voucherProductTemplateType = z.literal("VOUCHER");
const voucherProductTemplateZodObject = z.object({
    _id: productTemplateIdZodSchema,
    _type: z.literal("PRODUCT_TEMPLATE"),
    _status: entityStateZodSchema,
    meta: metaContentZodSchema,

    type: voucherProductTemplateType,

    templateDescription: templateDescriptionZodObject.optional(),
    // ^^ vet inte vad vi ska kalla de här egentligen, det kanske ger sig med tiden
    miniDescription: translatableZodSchema.optional(),

    // Maybe we should use meta.tags..
    // but at the same time, then meta tags
    // need a bit of an overhaul in it's
    // functionality, perhaps more like we intend
    // categories for product templates to work.
    // E.g. areas (part of meta tags) should probably
    // be it's own thing like categories then.
    // and same thing with delivery..
    // Maybe we should do that now as well.
    // We don't over use tags in the current meta,
    // but we do use it and it's a bit of a small
    // hassle to change.. 🤔
    tags: z.array(z.string()),
    contentBlocks: z.array(
        z.object({
            title: translatableZodSchema,
            content: translatableZodSchema,
        }),
    ),
});

type VoucherProductTemplate = z.infer<typeof voucherProductTemplateZodObject>;

type FactoryParams = Except<
    VoucherProductTemplate,
    "_id" | "_type" | "_status" | "type"
>;

const voucherProductTemplateFactory = (
    params: FactoryParams,
): VoucherProductTemplate => {
    return {
        ...params,
        _id: productTemplateIdFactory(),
        _status: "DRAFT",
        _type: "PRODUCT_TEMPLATE",
        type: "VOUCHER",
    };
};

const voucherProductTemplateCommandParamsZodObject = z.object({
    type: voucherProductTemplateType,
    meta: metaContentZodSchema,
    imageIds: z.array(storageItemImageIdZodSchema),
    tags: z.array(z.string()),

    contentBlocks: z.array(
        z.object({
            title: translatableZodSchema,
            content: translatableZodSchema,
        }),
    ),

    targetDescription: z
        .object({
            // Vem är detta för?
            text: translatableZodSchema,
        })
        .optional(),
    miniDescription: translatableZodSchema.optional(),

    // namngivning är svårt, vet inte om detta är så bra
    specifications:
        // lista med spec-grupper; titel, description and items (icon + text)
        z.array(templateSpecificationZodObject).optional(),

    suggestedPriceRange: z
        .object({
            min: priceZodSchema,
            max: priceZodSchema,
        })
        .optional(),
});

export {
    voucherProductTemplateCommandParamsZodObject as voucherProductTemplateCreateCommandParamsZodObject,
    voucherProductTemplateCommandParamsZodObject as voucherProductTemplateEditCommandParamsZodObject,
    voucherProductTemplateFactory,
    voucherProductTemplateZodObject,
};
export type { VoucherProductTemplate };
